import styled from 'styled-components';

export const FormSection = styled.div`
	/* color: #fff; */
	padding: 160px 0;
	/* background: ${({ inverse }) => (inverse ? "#060707" : '#fff')}; */
	background-color: rgba(242,242,242,255);
`;

export const FormTitle = styled.h1`
display: flex;
justify-content: center;
margin-bottom: 24px;
font-size: 48px;
line-height: 1.1;
font-weight: 600;
color:  #060707;
text-shadow: 2px 4px 3px rgba(0,0,0,0.3);
`;

